// MedicalCard.jsx
import React from 'react';
import { Card, Button, Table } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

/**
 * MedicalCard displays medical information in a table format.
 * It shows medical records and provides edit/delete actions.
 *
 * @param {Object} props
 * @param {Object} props.medicalData - The medical information to display
 * @param {Object} props.currentUser - The current user's information
 * @param {Function} props.onEdit - Callback when edit button is clicked
 * @param {Function} props.onDelete - Callback when delete button is clicked
 */
const MedicalCard = ({ medicalData, currentUser, onEdit, onDelete }) => {
    const { t } = useTranslation('medical');

    // Render a message if no data is available
    const renderNoData = (field) => (
        <span className="text-muted fst-italic">
            {t('fields.not_provided')}
        </span>
    );

    return (
        <Card className="shadow-lg p-4 mb-4 bg-light rounded">
            <Table striped bordered hover responsive>
                <thead>
                <tr>
                    <th>{t('fields.blood_type.label')}</th>
                    <th>{t('fields.medication.label')}</th>
                    <th>{t('fields.allergy.label')}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                        {medicalData.blood_type || renderNoData('blood_type')}
                    </td>
                    <td>
                        {medicalData.medication || renderNoData('medication')}
                    </td>
                    <td>
                        {medicalData.allergy || renderNoData('allergy')}
                    </td>
                </tr>
                </tbody>
            </Table>

            {/* Action Buttons */}
            <div className="d-flex justify-content-end mt-4">
                <Button
                    variant="outline-warning"
                    onClick={onEdit}
                    className="me-2 shadow-sm"
                >
                    <FaEdit className="me-1" /> {t('buttons.edit')}
                </Button>
                <Button
                    variant="outline-danger"
                    onClick={onDelete}
                    className="shadow-sm"
                >
                    <FaTrash className="me-1" /> {t('buttons.delete')}
                </Button>
            </div>
        </Card>
    );
};

export default MedicalCard;